(function () {
  // AMYAN ART — Cart drawer widgets (Free Shipping progress)
  // ------------------------------------------------------
  // Trước đây có 2 mốc (3 items -> Free Shipping / 5 items -> 15% Off +
  // Free Shipping), đồng bộ với product page qua localStorage. Theo yêu
  // cầu (09/2026), chỉ còn DUY NHẤT 1 chương trình: FREE SHIPPING khi mua
  // từ N items trở lên (mặc định 2, xem data-qty-threshold do các snippet
  // amyan-cart-offer-box.liquid / amyan-cart-progress-map.liquid render ra).
  // Ngưỡng này phải khớp với discount tự động " Free Shipping " thật trong
  // Shopify Admin → Discounts (điều kiện: số lượng >= N).
  //
  // Không còn đọc/ghi localStorage nữa — không còn gì để "chọn" cả.
  //
  // CẬP NHẬT (09/2026): dòng chữ ưu đãi ("Add X more item(s) to get FREE
  // SHIPPING" / "🎉 You've unlocked FREE SHIPPING!") đã CHUYỂN từ
  // <amyan-offer-box> sang <amyan-progress-map> (để nằm sát ngay trên
  // thanh progress, thay cho label tĩnh "FREE SHIPPING" cũ). <amyan-offer-box>
  // giờ chỉ còn vẽ icon xe tải + hàng chấm tiến độ, không còn chữ.

  var DEFAULT_QTY_THRESHOLD = 2;

  // <amyan-offer-box> — icon xe tải 🚚 + hàng chấm tiến độ trong cart
  // drawer. Không còn phần tử chữ (đã chuyển sang <amyan-progress-map>).
  // Re-initializes automatically every time it's inserted into the DOM
  // (including after the cart drawer content is replaced/morphed).
  if (!customElements.get('amyan-offer-box')) {
    class AmyanOfferBox extends HTMLElement {
      connectedCallback() {
        this._boundRefresh = this.refresh.bind(this);
        this.refresh();
        amyanPatchFetch();

        document.addEventListener('cart:updated', this._boundRefresh);
        document.addEventListener('cart:refresh', this._boundRefresh);
        document.addEventListener('cart:build', this._boundRefresh);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this._boundRefresh);
        document.removeEventListener('cart:refresh', this._boundRefresh);
        document.removeEventListener('cart:build', this._boundRefresh);
      }

      refresh() {
        var threshold = parseInt(this.dataset.qtyThreshold, 10) || DEFAULT_QTY_THRESHOLD;
        var dotsEl = this.querySelector('[data-amyan-cart-offerbox-dots]');
        if (!dotsEl) return;
        var self = this;

        function renderDots(itemCount) {
          if (dotsEl.children.length !== threshold) {
            dotsEl.innerHTML = '';
            for (var i = 0; i < threshold; i++) {
              var dot = document.createElement('span');
              dot.className = 'amyan-offer-box__dot';
              dotsEl.appendChild(dot);
            }
          }
          var filled = Math.max(0, Math.min(threshold, itemCount));
          Array.prototype.forEach.call(dotsEl.children, function (dot, idx) {
            dot.classList.toggle('is-filled', idx < filled);
          });
        }

        function render(itemCount) {
          if (typeof itemCount !== 'number' || isNaN(itemCount)) return;
          var remaining = threshold - itemCount;
          self.classList.toggle('is-complete', remaining <= 0);
          renderDots(itemCount);
        }

        var domItemCount = parseInt(self.dataset.itemCount, 10);
        if (!isNaN(domItemCount)) render(domItemCount);

        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            self.dataset.itemCount = cart.item_count;
            render(cart.item_count);
          })
          .catch(function () {});
      }
    }

    customElements.define('amyan-offer-box', AmyanOfferBox);
  }

  // <amyan-progress-map> — dòng chữ ưu đãi động + đường kẻ nối các chấm
  // tròn (progress track), sitting where the old "Get an extra 5% off...
  // checkout countdown" text used to be, at the top of the cart drawer.
  // Label giờ hiển thị đúng nội dung ưu đãi (trước đây ở <amyan-offer-box>),
  // KHÔNG còn là chữ tĩnh "FREE SHIPPING" nữa.
  if (!customElements.get('amyan-progress-map')) {
    class AmyanProgressMap extends HTMLElement {
      connectedCallback() {
        this._boundRefresh = this.refresh.bind(this);
        this.refresh();
        amyanPatchFetch();

        document.addEventListener('cart:updated', this._boundRefresh);
        document.addEventListener('cart:refresh', this._boundRefresh);
        document.addEventListener('cart:build', this._boundRefresh);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this._boundRefresh);
        document.removeEventListener('cart:refresh', this._boundRefresh);
        document.removeEventListener('cart:build', this._boundRefresh);
      }

      refresh() {
        var threshold = parseInt(this.dataset.qtyThreshold, 10) || DEFAULT_QTY_THRESHOLD;
        var labelEl = this.querySelector('[data-amyan-progress-map-label]');
        var trackEl = this.querySelector('[data-amyan-progress-map-track]');
        if (!labelEl || !trackEl) return;
        var self = this;

        function renderTrack(itemCount) {
          var expectedNodes = threshold + Math.max(0, threshold - 1);
          if (trackEl.children.length !== expectedNodes) {
            trackEl.innerHTML = '';
            for (var i = 0; i < threshold; i++) {
              var dot = document.createElement('span');
              dot.className = 'amyan-progress-map__dot';
              trackEl.appendChild(dot);
              if (i < threshold - 1) {
                var line = document.createElement('span');
                line.className = 'amyan-progress-map__line';
                trackEl.appendChild(line);
              }
            }
          }

          var filled = Math.max(0, Math.min(threshold, itemCount));
          var dots = trackEl.querySelectorAll('.amyan-progress-map__dot');
          var lines = trackEl.querySelectorAll('.amyan-progress-map__line');
          Array.prototype.forEach.call(dots, function (dot, idx) {
            dot.classList.toggle('is-filled', idx < filled);
          });
          Array.prototype.forEach.call(lines, function (line, idx) {
            line.classList.toggle('is-filled', filled >= idx + 2);
          });
        }

        function render(itemCount) {
          if (typeof itemCount !== 'number' || isNaN(itemCount)) return;
          var remaining = threshold - itemCount;

          if (remaining <= 0) {
            self.classList.add('is-complete');
            labelEl.classList.add('is-success');
            labelEl.innerHTML = "🎉 You've unlocked <strong>FREE SHIPPING</strong>!";
          } else {
            self.classList.remove('is-complete');
            labelEl.classList.remove('is-success');
            labelEl.innerHTML =
              'Add <strong>' + remaining + '</strong> more item' + (remaining > 1 ? 's' : '') +
              ' to get <strong>FREE SHIPPING</strong>';
          }
          renderTrack(itemCount);
        }

        var domItemCount = parseInt(self.dataset.itemCount, 10);
        if (!isNaN(domItemCount)) render(domItemCount);

        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            self.dataset.itemCount = cart.item_count;
            render(cart.item_count);
          })
          .catch(function () {});
      }
    }

    customElements.define('amyan-progress-map', AmyanProgressMap);
  }

  // Shared once-only patch: any /cart/ fetch (add/change/update) triggers a
  // refresh of every amyan-offer-box AND amyan-progress-map on the page.
  function amyanPatchFetch() {
    if (window.__amyanOfferBoxFetchPatched) return;
    window.__amyanOfferBoxFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var result = origFetch.apply(this, arguments);
      try {
        var url = (arguments[0] && arguments[0].url) || arguments[0];
        if (typeof url === 'string' && url.indexOf('/cart/') !== -1) {
          result.then(function () {
            document.querySelectorAll('amyan-offer-box, amyan-progress-map').forEach(function (el) {
              el.refresh();
            });
          });
        }
      } catch (e) {}
      return result;
    };
  }

  // <amyan-cart-timer> — looping urgency countdown. No longer rendered
  // anywhere in the cart drawer (the checkout-countdown text was removed),
  // but the definition is kept in case it's reused elsewhere later.
  if (!customElements.get('amyan-cart-timer')) {
    class AmyanCartTimer extends HTMLElement {
      connectedCallback() {
        var duration = parseInt(this.dataset.duration, 10) || 180;
        this.remaining = duration;
        this.duration = duration;
        this.render();
        this.interval = setInterval(() => {
          this.remaining -= 1;
          if (this.remaining <= 0) this.remaining = this.duration;
          this.render();
        }, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      render() {
        var m = Math.floor(this.remaining / 60);
        var s = this.remaining % 60;
        this.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }
    }

    customElements.define('amyan-cart-timer', AmyanCartTimer);
  }
})();